import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  width: 100%;
  height: 96vh;
  background-color: ${({ theme }) => theme.neutral.white};
  .MuiTabs-scroller.MuiTabs-fixed {
    margin-left: 1.5rem;
  }
`;

export const useStyles = makeStyles(() => ({
  delete: {
    color: theme.status.error,
  },
  tabs: {
    backgroundColor: theme.background.light,
  },
}));
